import Vue from 'vue'
import Vuex from 'vuex'
import analyticDataStore from './modules/analyticData.store';
import listDataStore from './modules/listData.store';
import planStore from './modules/plan.store';
import stockStore from './modules/stock.store';
import userStore from './modules/user.store';
import routerStore from './modules/router.store';
import preferenceStore from './modules/preference.store';
import stockBaseInfoStore from './modules/stockBaseInfo.store';
import userDataStore from './modules/userData.store';
import portfoliosStore from './modules/portfolios.store';
import friendsStore from './modules/friends.store';

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        user: userStore,
        list: listDataStore,
        analytic: analyticDataStore,
        plan: planStore,
        stock: stockStore,
        stockBaseInfo: stockBaseInfoStore,
        router: routerStore,
        preference: preferenceStore,
        userData: userDataStore,
        portfolio: portfoliosStore,
        friends: friendsStore
    }
})
